import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Button, Card, CardActions, CardContent, CardHeader, Divider } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import clsx from 'clsx';
import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { Link, useHistory } from 'react-router-dom';
import { DashboardPanelContext } from '../../../../components/context/DashboardContext';
import BSubmitButton from '../../../../components/buttons/SubmitButton';
import BCheckBoxField from '../../../../components/inputs/forms/BCheckBoxField';
import { REQUIRED_STRING } from '../../../../constants/HookForm';
import BTextField from '../../../../components/inputs/forms/BTextField';
import {
  setValues,
  onChangeForBComponents,
  onKeyDownHandlerOnlyAcceptEnglishCharacterAndNumbers,
} from '../../../../common/utilities';
import { BSwalShowError } from '../../../../common/BSwal';
import useHistoryForms from '../../../../hooks/useHistoryForms';
import BHistoryNavigator from '../../../../components/BHistoryNavigator';
import useBasicInformationMountedEffect from '../../../../hooks/useBasicInformationMountedEffect';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  customInputFormControl: {
    width: '100%',
  },
  formLabel: {
    fontSize: 16,
    marginBottom: 10,
  },
}));

const initialStatus = {
  title: '',
  status: true,
};

const OrderStatusesPage = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const { staticContext, ...rest } = props;
  const { globalState, saveItem } = useContext(DashboardPanelContext);

  const { viewReadOnly } = globalState;

  const [loading, setLoading] = useState(false);
  const { errors, handleSubmit, setValue, register } = useForm();

  const {
    fetchData,
    prevHistory,
    nextHistory,
    HistoryId,
    historyIdList,
    historyStep,
    history: fetchedHistory,
    historyInfo,
  } = useHistoryForms({
    location: props.location,
    route: '/order-management/statuses',
  });

  const {
    id,
    item: currentStatus,
    setItem: setCurrentStatus,
  } = useBasicInformationMountedEffect({
    match: props.match,
    historyIdList,
    fetchItemURL: '/order-statuses',
    localStorageKey: 'order-statuses',
    initialItem: initialStatus,
    fetchData,
    historyId: HistoryId,
  });

  useEffect(() => {
    if (!viewReadOnly) {
      register(
        { name: 'title' },
        {
          required: REQUIRED_STRING,
        },
      );
    }
  }, []);

  useEffect(() => {
    if (currentStatus.data) {
      setCurrentStatus(currentStatus.data);
    }
    if (currentStatus) {
      setValues(setValue, currentStatus);
    }
  }, [currentStatus]);

  useEffect(() => {
    if (fetchedHistory && historyIdList.length !== 0) {
      setCurrentStatus(fetchedHistory);
    }
  }, [fetchedHistory]);

  const onSubmit = () => {
    setLoading(true);
    const status = { ...currentStatus };
    if (currentStatus.status) {
      status.status = '1';
    } else {
      status.status = '0';
    }
    saveItem('order-statuses', status, id)
      .then(() => history.push('/order-management/statuses'))
      .catch((err) => BSwalShowError(err?.data?.messages))
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    onChangeForBComponents(e, setValue, currentStatus, setCurrentStatus);
  };

  return (
    <div className={classes.root} style={{ margin: 10 }}>
      {currentStatus && (
        <Card {...rest} className={clsx(classes.root)}>
          <Button
            id='backToListIcon'
            component={Link}
            to={{
              pathname: '/order-management/statuses',
            }}
            color='secondary'
            variant='outlined'
            style={{ float: 'right', marginTop: '10px', marginRight: '10px' }}
          >
            <ArrowBackIcon />
          </Button>
          <form className='formContainer' onSubmit={handleSubmit(onSubmit)}>
            <CardHeader title='Order Status Information' />
            <Divider />
            <CardContent>
              <br />
              {historyInfo}
              <Grid container spacing={3}>
                <BTextField
                  label='Title'
                  name='title'
                  value={currentStatus?.title}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptEnglishCharacterAndNumbers}
                  error={errors.title}
                  required
                />

                <BCheckBoxField
                  sm={12}
                  name='status'
                  label='Enabled Status'
                  value={Number(currentStatus?.status)}
                  error={errors.status}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Grid item xs={12} sm={6}>
                {!viewReadOnly && <BSubmitButton id='submitEmployee' label='Save Order Status' loading={loading} />}
              </Grid>
              <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  id='backToList'
                  component={Link}
                  to={{
                    pathname: '/order-management/statuses',
                  }}
                  color='secondary'
                  variant='outlined'
                >
                  Back to Order Status list
                </Button>
              </Grid>
            </CardActions>
          </form>
          <BHistoryNavigator
            historyStep={historyStep}
            historyIdList={historyIdList}
            prevHistory={prevHistory}
            nextHistory={nextHistory}
          />
        </Card>
      )}
    </div>
  );
};

OrderStatusesPage.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
};

export default OrderStatusesPage;
